import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { ISystemStatusState } from 'types/systemStatus.types';

import { IAppState } from 'types/app.types';
import { IAuthState } from 'types/auth.types';
import { IBlocksState } from 'types/blocks.types';
import { ICategoryPricesState } from 'types/categoryPrices.types';
import { ICementeriesState } from 'types/cementeries.types';
import { IContactSettingsState } from 'types/contactSettings.types';
import { IDeathsState } from 'types/deaths.types';
import { IDivorcesState } from 'types/divorces.types';
import { IDocumentsState } from 'types/documents.types';
import { IDocumentsTypesState } from 'types/documentsTypes.types';
import { IGravesState } from 'types/graves.types';
import { IJewishnessState } from 'types/jewishness.types';
import { IMarriagesState } from 'types/marriages.types';
import { IMatzevaState } from 'types/matzeva.types';
import { IPermissionsState } from 'types/permissions.types';
import { IPersonsState } from 'types/persons.types';
import { IProceduresState } from 'types/procedures.types';
import { IProceduresEmailsState } from 'types/proceduresEmails.types';
import { IReservationsState } from 'types/reservations.types';
import { IRolesState } from 'types/roles.types';
import { IUsersState } from 'types/users.types';

export interface IRootState {
  app: IAppState;
  auth: IAuthState;
  blocks: IBlocksState;
  categoryPrices: ICategoryPricesState;
  cementeries: ICementeriesState;
  contactSettings: IContactSettingsState;
  divorces: IDivorcesState;
  deaths: IDeathsState;
  documents: IDocumentsState;
  documentsTypes: IDocumentsTypesState;
  graves: IGravesState;
  jewishness: IJewishnessState;
  systemStatus: ISystemStatusState;
  marriages: IMarriagesState;
  matzeva: IMatzevaState;
  permissions: IPermissionsState;
  persons: IPersonsState;
  procedures: IProceduresState;
  proceduresEmails: IProceduresEmailsState;
  roles: IRolesState;
  reservations: IReservationsState;
  users: IUsersState;
}

const useTypedSelector: TypedUseSelectorHook<IRootState> = useSelector;

export default useTypedSelector;
